import { Dispatch, MouseEventHandler, SetStateAction } from "react";
import { Button } from "reactstrap";
import { callFunctionIfExists } from "../utils/GeneralUtils";
import AppSpinner from "./AppSpinner";

interface EditSaveButtonProps {
  isEditing: boolean;
  isSubmitting: boolean;
  setIsEditing: Dispatch<SetStateAction<boolean>>;
  onCancel?: () => void;
  onSave?: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
}

const EditSaveButton = ({
  isEditing,
  setIsEditing,
  onCancel,
  onSave,
  isSubmitting,
  disabled,
}: EditSaveButtonProps) => {
  if (isEditing) {
    return (
      <>
        <Button
          size="sm"
          color="secondary"
          outline
          onClick={() => {
            callFunctionIfExists(onCancel);
            setIsEditing(false);
          }}
        >
          Cancel
        </Button>
        <Button
          size="sm"
          color="primary"
          onClick={onSave}
          disabled={isSubmitting || disabled}
          style={{ width: 75 }}
        >
          {isSubmitting ? <AppSpinner size="sm" color="white" /> : <>Save</>}
        </Button>
      </>
    );
  }

  return (
    <Button size="sm" outline onClick={() => setIsEditing(true)}>
      Edit
    </Button>
  );
};

export default EditSaveButton;
